import React from 'react';
import { Edit, Trash2, Copy } from 'lucide-react';

interface EventContextMenuProps {
  x: number;
  y: number;
  onEdit: () => void;
  onCopy: () => void;
  onDelete: () => void;
  editLabel: string;
  copyLabel: string;
  deleteLabel: string;
}

const EventContextMenu: React.FC<EventContextMenuProps> = ({
  x,
  y,
  onEdit,
  onCopy,
  onDelete,
  editLabel,
  copyLabel,
  deleteLabel,
}) => {
  return (
    <div
      className="fixed z-50 min-w-[160px] rounded-md border bg-popover p-1 shadow-md"
      style={{ left: x, top: y }}
    >
      <button
        className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
        onClick={onEdit}
      >
        <Edit className="h-4 w-4" />
        {editLabel}
      </button>
      <button
        className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
        onClick={onCopy}
      >
        <Copy className="h-4 w-4" />
        {copyLabel}
      </button>
      <button
        className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-destructive hover:bg-accent hover:text-destructive"
        onClick={onDelete}
      >
        <Trash2 className="h-4 w-4" />
        {deleteLabel}
      </button>
    </div>
  );
};

export default EventContextMenu;
